import comp from "./AcademicRecordsModal";
export default comp;
